/* The header's 'A' Icon, links to home. */

import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import routes from 'sitewide-js/core_pre_webpack/routes';
import _Link from "AcademiaIcon-Link.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/AcademiaIcon.tsx?styleId=Link";


const REDUCE_MARGIN_SIZE = 625; // px

const Link = /*#__PURE__*/styled("a", null, {
  displayName: "Link",
  styles: _Link
});

type Props = {
  style?: React.CSSProperties;
};

const AcademiaIcon = ({ style }: Props) => (
  <Link href={routes.home_url()} style={style}>
    <img src={$image_url('academia-logo-2021.svg')} />
  </Link>
);

export default AcademiaIcon;
